<template>
    <transition name="fade">
      <!-- El popup será visible solo cuando visible sea true -->
      <div
        v-if="visible"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      >
        <!-- Caja del mensaje de error -->
        <div class="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
          <h2>{{ title }}</h2>
          <p class="mt-2 text-gray-700">{{ message }}</p>
          
          <div class="flex justify-end gap-4 mt-4" style="margin-top: 30px;">
            <button @click="cancelPopup" class="secondary_button" style="width: 45%; margin-right: 5%;" >{{ cancelButton }}</button>
            <button @click="acceptPopup" class="main_button" style="width: 45%; margin-right: 5%;">{{ acceptButton }}</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  
  // Define las props del componente para recibir el mensaje de error
  const props = defineProps({
    title: String,
    message: String,
    acceptButton: String,
    cancelButton: String,
  });

  const emit = defineEmits(['acceptCallback', 'cancelCallback']);

  const visible = ref(false);
  
  // Hacer visible el popup cuando haya un mensaje de error
  watch(() => props.title, (newVal) => {
    visible.value = !!newVal;
  });
  
  const acceptPopup = () => {
    visible.value = false;
    emit('acceptCallback');
  };

  const cancelPopup = () => {
    visible.value = false;
    emit('cancelCallback');
  };
</script>
  
  <style scoped>
  /* Estilo de transición para suavizar la aparición/desaparición del popup */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  /* Fondo translúcido detrás del popup */
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 50; /* Asegura que el popup esté sobre el contenido */
  }
  
  /* Estilo de la caja que contiene el error */
  .bg-white {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 80%; /* Puedes ajustar el ancho de la caja */
    max-width: 600px; /* Ajusta el tamaño máximo */
    text-align: center;
  }
  
  </style>
  